import { ZoomAdminManagedUsersPage } from '@features/zoom-admin-managed/components/ZoomAdminManagedUsersPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/admin/_zoomRollout/zoom/users')({
  component: ZoomAdminManagedUsersPage,
});
